module.exports = __webpack_public_path__ + "img/lt-icone-facebook-gris-clair.4d171938.svg";